module.exports = __webpack_public_path__ + "static/media/cobuLogo.b2e35518.svg";